
const AUDIO_MIME_TYPES = [
    'audio/mpeg',
    'audio/aac',
    'audio/midi',
    'audio/x-midi',
    'audio/ogg',
    'audio/opus',
    'audio/wav',
    'audio/webm',
];

const AUDIO_EXTENSIONS = [
    'mp3',
    'aac',
    'mid',
    'midi',
    'oga',
    'opus',
    'wav',
    'weba',
];

const AUDIO_MAX_SIZE = 50 * 1024 * 1024;

export {
    AUDIO_MIME_TYPES,
    AUDIO_EXTENSIONS,
    AUDIO_MAX_SIZE,
};
